/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

export const PLANS = [
 {
  "key": "online",
  "cls": "plan--studio plan--online",
  "badge": "کلاس آنلاین سکویا",
  "badgeDana": false,
  "fav": false,
  "overlays": 1,
  "features": [
   [
    1,
    "جلسه آنلاین خصوصی یا نیمه‌خصوصی با مربی"
   ],
   [
    1,
    "اصلاح تکنیک اجرا به‌صورت زنده و همزمان"
   ],
   [
    1,
    "هماهنگی زمان جلسات با مربی"
   ]
  ],
  "prices": null,
  "btn": {
   "href": "https://app.sequoia.fitness/new-order",
   "text": "ظرفیت تکمیل شد! (رزرو)",
   "full": true,
   "parts": [
    "ظرفیت تکمیل شد! (رزرو)",
    "رزرو کن"
   ]
  }
 },
 {
  "key": "training",
  "cls": "plan--exercise",
  "badge": "برنامه تمرینی",
  "badgeDana": false,
  "fav": false,
  "overlays": 2,
  "features": [
   [
    1,
    "برنامه تمرینی شخصی‌سازی‌شده"
   ],
   [
    0,
    "برنامه غذایی شخصی‌سازی‌شده"
   ],
   [
    0,
    "تمرین‌های اصلاحی و ارزیابی پوسچر"
   ],
   [
    1,
    "پشتیبانی استاندارد: دسترسی مستقیم به مربی از طریق سکویا چت جهت مشاوره"
   ],
   [
    0,
    "بازخورد مستمر و پشتیبانی اولویت‌دار"
   ],
   [
    0,
    "آنالیز ماهانه Body Composition"
   ],
   [
    0,
    "جلسه حضوری یا ویدئوکال با مربی"
   ]
  ],
  "prices": {
   "1": 3000000,
   "3": 7650000,
   "12": 28800000
  },
  "btn": {
   "href": "https://app.sequoia.fitness/new-order",
   "text": "شروع کن",
   "full": false,
   "parts": []
  }
 },
 {
  "key": "nutrition",
  "cls": "",
  "badge": "برنامه غذایی",
  "badgeDana": false,
  "fav": false,
  "overlays": 2,
  "features": [
   [
    1,
    "برنامه غذایی شخصی‌سازی‌شده"
   ],
   [
    0,
    "برنامه تمرینی شخصی‌سازی‌شده"
   ],
   [
    0,
    "تمرین‌های اصلاحی و ارزیابی پوسچر"
   ],
   [
    1,
    "پشتیبانی استاندارد: دسترسی مستقیم به مربی از طریق سکویا چت جهت مشاوره"
   ],
   [
    0,
    "بازخورد مستمر و پشتیبانی اولویت‌دار"
   ],
   [
    0,
    "آنالیز ماهانه Body Composition"
   ],
   [
    0,
    "جلسه حضوری یا ویدئوکال با مربی"
   ]
  ],
  "prices": {
   "1": 1000000,
   "3": 2550000,
   "12": 9600000
  },
  "btn": {
   "href": "https://app.sequoia.fitness/new-order",
   "text": "شروع کن",
   "full": false,
   "parts": []
  }
 },
 {
  "key": "fix",
  "cls": "",
  "badge": "تمرینات اصلاحی",
  "badgeDana": false,
  "fav": false,
  "overlays": 2,
  "features": [
   [
    1,
    "یک جلسه مشاوره حضوری یا آنلاین جهت انجام و بررسی تست‌های لازم"
   ],
   [
    1,
    "برنامه اصلاحی-تمرینی شخصی‌سازی‌شده"
   ],
   [
    1,
    "برنامه تمرینی شخصی‌سازی‌شده"
   ],
   [
    0,
    "برنامه غذایی شخصی‌سازی‌شده"
   ],
   [
    1,
    "تمرین‌های اصلاحی و ارزیابی پوسچر"
   ],
   [
    1,
    "پشتیبانی استاندارد: دسترسی مستقیم به مربی از طریق سکویا چت جهت مشاوره"
   ],
   [
    0,
    "بازخورد مستمر و پشتیبانی اولویت‌دار"
   ],
   [
    0,
    "آنالیز ماهانه Body Composition"
   ],
   [
    0,
    "جلسه حضوری یا ویدئوکال با مربی"
   ]
  ],
  "prices": {
   "1": 4000000
  },
  "btn": {
   "href": "https://app.sequoia.fitness/new-order",
   "text": "شروع کن",
   "full": false,
   "parts": []
  }
 },
 {
  "key": "complete",
  "cls": "plan--fav",
  "badge": "برنامه تمرینی + غذایی",
  "badgeDana": false,
  "fav": true,
  "overlays": 2,
  "features": [
   [
    1,
    "دسترسی به ویدیوهای تمرینی"
   ],
   [
    1,
    "دسترسی کامل به ابزارها و حساب‌گرها"
   ],
   [
    1,
    "دسترسی به سیستم ثبت برنامه تمرینی شخصی"
   ],
   [
    1,
    "دسترسی به ثبت و سیستم پیگیری روند پیشرفت هر ۲۱ روز"
   ],
   [
    1,
    "برنامه تمرینی شخصی‌سازی‌شده"
   ],
   [
    1,
    "برنامه غذایی شخصی‌سازی‌شده"
   ],
   [
    1,
    "پشتیبانی استاندارد: دسترسی مستقیم به مربی از طریق سکویا چت جهت مشاوره"
   ],
   [
    0,
    "بازخورد مستمر و پشتیبانی اولویت‌دار"
   ],
   [
    0,
    "آنالیز ماهانه Body Composition"
   ],
   [
    0,
    "جلسه حضوری یا ویدئوکال با مربی"
   ]
  ],
  "prices": {
   "1": 3500000,
   "3": 8925000,
   "12": 33600000
  },
  "btn": {
   "href": "https://app.sequoia.fitness/new-order",
   "text": "شروع کن",
   "full": false,
   "parts": []
  }
 },
 {
  "key": "pro",
  "cls": "plan--pro",
  "badge": "Sequoia Pro",
  "badgeDana": true,
  "fav": false,
  "overlays": 1,
  "features": [
   [
    1,
    "دسترسی به آرشیو تمرین‌ها و ویدیوهای آموزشی"
   ],
   [
    1,
    "دسترسی کامل به برنامه‌ساز سکویا"
   ],
   [
    1,
    "دسترسی به سیستم پیگیری روند پیشرفت"
   ],
   [
    1,
    "دسترسی کامل به ابزارها و حساب‌گرها"
   ],
   [
    1,
    "دسترسی به سیستم ثبت برنامه تمرینی شخصی"
   ],
   [
    1,
    "امکان ارتقا به سایر پلن‌ها در هفته‌ی اول فعال‌سازی بدون هزینه‌ی اضافی"
   ],
   [
    0,
    "برنامه تمرینی شخصی‌سازی‌شده"
   ],
   [
    0,
    "برنامه غذایی شخصی‌سازی‌شده"
   ],
   [
    0,
    "پشتیبانی استاندارد: دسترسی مستقیم به مربی از طریق سکویا چت جهت مشاوره"
   ]
  ],
  "prices": {
   "1": 899000,
   "3": 2697000
  },
  "btn": {
   "href": "https://app.sequoia.fitness/new-order",
   "text": "شروع کن",
   "full": false,
   "parts": []
  }
 },
 {
  "key": "elite",
  "cls": "plan--vip",
  "badge": "Elite",
  "badgeDana": true,
  "fav": false,
  "overlays": 2,
  "features": [
   [
    1,
    "برنامه غذایی شخصی‌سازی‌شده"
   ],
   [
    1,
    "برنامه تمرینی شخصی‌سازی‌شده"
   ],
   [
    1,
    "تمرین‌های اصلاحی و ارزیابی پوسچر"
   ],
   [
    1,
    "بازخورد مستمر و پشتیبانی اولویت‌دار"
   ],
   [
    1,
    "آنالیز ماهانه Body Composition"
   ],
   [
    1,
    "طراحی و برنامه‌ریزی روند سه‌ماهه"
   ],
   [
    1,
    "پشتیبانی حرفه‌ای: امکان تماس تصویری و یا دریافت مشاوره حضوری به‌صورت ماهانه"
   ],
   [
    0,
    "جلسه تمرین حضوری یا آنلاین با نظارت مربی در طول ماه"
   ]
  ],
  "prices": {
   "3": 15000000,
   "12": 48000000
  },
  "btn": {
   "href": "https://app.sequoia.fitness/new-order",
   "text": "شروع کن",
   "full": false,
   "parts": []
  }
 },
 {
  "key": "apex",
  "cls": "",
  "badge": "APEX",
  "badgeDana": true,
  "fav": false,
  "overlays": 2,
  "features": [
   [
    1,
    "برنامه غذایی شخصی‌سازی‌شده"
   ],
   [
    1,
    "برنامه تمرینی شخصی‌سازی‌شده"
   ],
   [
    1,
    "تمرین‌های اصلاحی و ارزیابی پوسچر"
   ],
   [
    1,
    "بازخورد مستمر و پشتیبانی اولویت‌دار"
   ],
   [
    1,
    "آنالیز ماهانه Body Composition"
   ],
   [
    1,
    "طراحی و برنامه‌ریزی روند سه‌ماهه"
   ],
   [
    1,
    "پشتیبانی حرفه‌ای: امکان تماس تصویری و یا دریافت مشاوره حضوری به‌صورت هفتگی"
   ],
   [
    1,
    "یک جلسه تمرین حضوری یا آنلاین با نظارت مربی در طول ماه"
   ]
  ],
  "prices": {
   "3": 18000000,
   "12": 57600000
  },
  "btn": {
   "href": "https://app.sequoia.fitness/new-order",
   "text": "شروع کن",
   "full": false,
   "parts": []
  }
 },
 {
  "key": "studio",
  "cls": "plan--studio",
  "badge": "کلاس حضوری سکویا استودیو",
  "badgeDana": false,
  "fav": false,
  "overlays": 1,
  "features": [
   [
    1,
    "جلسه تمرین حضوری خصوصی یا نیمه‌خصوصی با مربی"
   ],
   [
    1,
    "جلسه‌ی آشنایی، شروع تمرین و مشاوره‌ی کامل"
   ],
   [
    1,
    "آنالیز و ارزیابی Body Composition"
   ],
   [
    1,
    "ارزیابی پوسچر بدنی"
   ],
   [
    1,
    "برنامه‌ریزی و هماهنگی زمان با مربی"
   ],
   [
    1,
    "تماس مربی ظرف حداکثر یک هفته بعد از رزرو"
   ]
  ],
  "prices": null,
  "btn": {
   "href": "https://app.sequoia.fitness/new-order",
   "text": "ظرفیت تکمیل شد! (رزرو)",
   "full": true,
   "parts": [
    "ظرفیت تکمیل شد! (رزرو)",
    "رزرو کن"
   ]
  }
 }
]
